import { render, staticRenderFns } from "./MessageWithoutHeader.vue?vue&type=template&id=4a96f4cb&"
import script from "./MessageWithoutHeader.vue?vue&type=script&lang=js&"
export * from "./MessageWithoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./MessageWithoutHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports